const GuideChecklist = () => {
  const checklistItems = [
    {
      category: '初回面談で確認すること',
      items: [
        '料金体系とサービス内容の説明が明確か',
        '質問に対して丁寧に答えてくれるか',
        'あなたの業種の経験があるか',
        '訪問頻度や連絡方法について説明があるか',
        '節税対策について具体的な提案があるか',
      ],
    },
    {
      category: '契約前に確認すること',
      items: [
        '契約書の内容が明確か',
        '解約条件が明記されているか',
        '追加費用が発生する場合の説明があるか',
        '担当者が誰になるか明確か',
        '緊急時の連絡方法が確立されているか',
      ],
    },
    {
      category: '契約後に期待すること',
      items: [
        '定期的な訪問や面談がある',
        '月次決算書の説明がわかりやすい',
        '税務調査の立会いをしてくれる',
        '経営改善の提案がある',
        'レスポンスが早い',
      ],
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-4">
            税理士選びの<br className="sm:hidden" />チェックリスト
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            面談時や契約時に確認すべきポイントをまとめました
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {checklistItems.map((section, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-red/5 to-white border border-red/20 rounded-2xl p-6 sm:p-8"
            >
              <div className="flex items-center gap-3 mb-4 sm:mb-6">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-red rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-base sm:text-lg">{index + 1}</span>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900">
                  {section.category}
                </h3>
              </div>
              <ul className="space-y-3 sm:space-y-4">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <div className="w-5 h-5 sm:w-6 sm:h-6 border-2 border-red rounded flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-red text-xs sm:text-sm"></i>
                    </div>
                    <span className="text-sm sm:text-base text-gray-700 leading-relaxed">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 bg-gradient-to-br from-red-dark to-red rounded-2xl p-6 sm:p-10 text-center">
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4 px-4">
            赤石会計事務所なら<br className="sm:hidden" />すべてクリア
          </h3>
          <p className="text-base sm:text-lg text-white/90 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            上記のチェックリストすべてに対応しています。<br className="hidden sm:block" />
            まずは無料相談で、あなたのビジネスについてお聞かせください。
          </p>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfcI_iqOXmdZhJO8vkCvjObLY5GxPIAQ8kXxWKDFswsKGrSRQ/viewform?usp=publish-editor"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-red px-8 sm:px-10 py-3 sm:py-4 rounded-full text-sm sm:text-[15px] font-medium hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            無料相談を予約する
          </a>
        </div>
      </div>
    </section>
  );
};

export default GuideChecklist;
